import 'core-js/stable';
import './bootstrap';

import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VModal from 'vue-js-modal';
import VueGtag from 'vue-gtag';
import { mapActions, mapState } from 'vuex';

import autosize from 'autosize';
import fitvids from 'fitvids';
import Flickity from 'flickity';
import ColorThief from 'colorthief';
import Notifications from 'vue-notification';
import VueScrollTo from 'vue-scrollto';

import 'url-search-params-polyfill';
import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';

import store from './store';
import ArticleSidebar from './components/ArticleSidebar.vue';
import AvatarUpdateModal from './components/AvatarUpdateModal.vue';
import AvatarImage from './components/AvatarImage.vue';
import Boolean from '../admin/global/fields/Boolean.vue';
import DatePicker from '../admin/global/fields/DatePicker.vue';
import Comments from './components/Comments/Comments.vue';
import DepartmentDropdown from './components/DepartmentDropdown.vue';
import Dashboard from './components/Dashboard/Dashboard.vue';
import FaqItem from './components/FaqItem.vue';
import FavoriteAction from './components/FavoriteAction.vue';
import InitStore from './components/InitStore.vue';
import LikeAction from './components/LikeAction.vue';
import MobileDepartmentMenu from './components/MobileDepartmentMenu.vue';
import RemoteMenu from './components/RemoteMenu.vue';
import ResourceSidebar from './components/ResourceSidebar.vue';
import SearchMachine from './components/SearchMachine/SearchMachine.vue';
import SearchMachineForm from './components/SearchMachine/SearchMachineForm.vue';
import SearchMachineLoader from './components/SearchMachine/SearchMachineLoader.vue';
import SearchOverlay from './components/SearchOverlay.vue';
import TimeDate from './components/TimeDate.vue';
import TimezoneField from './components/TimezoneField.vue';
import UserDropdown from './components/UserDropdown.vue';

/**
 * Use Vue Notifications for toast messages
 */
Vue.use(Notifications);

/**
 * Use Vue ScrollTo for...scrolling
 */
Vue.use(VueScrollTo, {
    easing: [0.39, 0.575, 0.565, 1],
});

/**
 * Use VTooltip for toolips
 */
Vue.use(VTooltip);

/**
 * Use VMdadl for base modals
 */
Vue.use(VModal);

/**
 * Use VueGtag for analytics integration
 */
Vue.use(VueGtag, {
    config: { id: 'UA-7645120-7' },
    disableScriptLoad: true,
    globalObjectName: 'vuegtag'
});

/**
 * Root Vue instance
 */
new Vue({
    el: '#app',
    store,
    components: {
        InitStore,
        AvatarImage,
        Comments,
        Dashboard,
        DepartmentDropdown,
        UserDropdown,
        AvatarUpdateModal,
        RemoteMenu,
        SearchOverlay,
        TimezoneField,
        SearchMachine,
        SearchMachineForm,
        FavoriteAction,
        ArticleSidebar,
        ResourceSidebar,
        LikeAction,
        Boolean,
        DatePicker,
        FaqItem,
        TimeDate,
        SearchMachineLoader,
        MobileDepartmentMenu,
    },
    computed: {
        ...mapState(['showRemoteMenu', 'showSearchOverlay']),
    },
    methods: {
        ...mapActions([
            'toggleDepartmentDropdown',
            'toggleUserDropdown',
            'toggleRemoteMenu',
            'toggleSearchOverlay',
            'showAvatarModal',
            'toggleMobileDepartmentsMenu',
        ]),
        showAvatarModal() {
            this.toggleUserDropdown();
            this.$modal.show('avatar-update');
        },
    },
});

/**
 * Use fitvids for responsive iframes (e.g. resource pdfs)
 */
fitvids({
    players: ['iframe[src]'],
});

const photoSliders = document.querySelectorAll('.photoSlider');

if (photoSliders) {
    Array.from(photoSliders).forEach((photoSlider) => {
        new Flickity(photoSlider, {
            pageDots: false,
            wrapAround: true,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 65,
                y2: 45,
                x3: 20,
            },
            cellAlign: 'left',
            on: {
                ready() {
                    this.element.classList.remove('js-loading');
                },
            },
        });
    });
}


const imageSliders = document.querySelectorAll('.imageCardSlider');

if (imageSliders) {
    Array.from(imageSliders).forEach((imageSlider) => {
        const slideCount = imageSlider.getAttribute('data-slide-count');
        new Flickity(imageSlider, {
            pageDots: false,
            wrapAround: slideCount > 2,
            prevNextButtons: slideCount > 2,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 65,
                y2: 45,
                x3: 20,
            },
            cellAlign: 'left',
            setGallerySize: false,
            on: {
                ready() {
                    const colorThief = new ColorThief();
                    const slides = this.element.querySelectorAll('.imageCard');
                    slides.forEach((slide) => {
                        const slideImage = slide.querySelector('.imageCard__image img');
                        const slideOverlay = slide.querySelector('.imageCard__imageOverlay');

                        // Make sure image is loaded before trying to get color information
                        slideImage.addEventListener('load', () => {
                            const dominantColor = colorThief.getColor(slideImage);
                            const [red, green, blue] = dominantColor;

                            // slideOverlay.style.backgroundImage = `linear-gradient(to top, rgba(${red}, ${green}, ${blue}, 0.7), rgba(${red}, ${green}, ${blue}, 0))`;
                            slideOverlay.style.background = `rgba(${red}, ${green}, ${blue}, 0.3) linear-gradient(to top, rgba(${red}, ${green}, ${blue}, 0.7), rgba(${red}, ${green}, ${blue}, 0))`;
                        });
                    });
                    this.element.classList.remove('js-loading');
                },
            },
        });
    });
}

const iconCardSliders = document.querySelectorAll('.iconCardSlider');

if (iconCardSliders) {
    Array.from(iconCardSliders).forEach((iconCardSlider) => {
        const slideCount = iconCardSlider.getAttribute('data-slide-count');
        new Flickity(iconCardSlider, {
            pageDots: false,
            wrapAround: slideCount > 4,
            prevNextButtons: slideCount > 3,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 65,
                y2: 45,
                x3: 20,
            },
            cellAlign: 'left',
            on: {
                ready() {
                    this.element.classList.remove('js-loading');
                },
            },
        });
    });
}

/**
 * Automatically resize text areas based on content
 */
autosize(document.querySelectorAll('textarea'));
